import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Header from '../common/Header';
import SubHeader from '../common/SubHeader';
import TransactionLogs from './TransactionLogs';
import SearchBar from '../common/SearchBar';
import { resetFilter } from '../../features/fliter/filterSlice';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { resetPage } from '../../features/pagecount/pageSlice';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const Logs = () => {
  const [search, setsearch] = useState('');

  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
  const history = useHistory();
  const policies = returnPolicies();

  const handleSearch = (value) => {
    setsearch(value.toUpperCase());
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetFilter());
    dispatch(resetPage());
    dispatch(resetVendorFilter());
  }, []);

  useEffect(() => {
    if (policies?.logPolicies?.canAccess === false) {
        history.push('/');
      }
  }, [policies]);

  return (
    <div className="md:w-full">
      <Header parentPageLink="/" currentPage="Transaction Logs" headerName="Logs" />
      <div className="manning-wrapper">
        <SubHeader
          pageNumber={pageNumber}
          rowsCount={rowsCount}
          searchComponent={<SearchBar handleSearch={handleSearch} search={search} placeholder="Search PO number (Minimum 3 characters)" additionalClassName="search-input-width" />}
        />

        <TransactionLogs
        search={search}
        pageNumber={pageNumber}
        setpageNumber={setpageNumber}
        rowsCount={rowsCount}
        setrowsCount={setrowsCount}
        />
      </div>
    </div>
  );
};

export default Logs;
